import { IconContext } from './context';
var IconProvider = IconContext.Provider;
export { default as Icon } from './icon';
export * from './react';
export { IconProvider };